import { type SelectionsMachine } from '../../../machine/selection-machine';
import { isCellSelected } from '../../../machine/utils/is-cell-selected';
import { isSelectAll } from '../../../machine/utils/is-select-all';
import { type ClickTarget } from '../utils/get-click-target';

export interface SelectionModifiers {
  extend?: boolean;
  toggle?: boolean;
}

export function dispatchInitialClick(
  machine: SelectionsMachine,
  target: ClickTarget,
  modifiers: SelectionModifiers = {}
): void {
  const { extend = false, toggle = false } = modifiers;
  const state = machine.getState();

  if (target.type === 'headerCheckbox') {
    // Check if the special SELECT_ALL_RANGE_ID is in our selections range
    const hasSelectAllRange =
      state.selections.length > 0 && isSelectAll(state.selections[0], state.mode);

    if (hasSelectAllRange) {
      // If we have the special select all range, we are deselecting on click
      machine.dispatch({ type: 'deselectAll', source: 'mouse' });
    } else {
      machine.dispatch({ type: 'selectAll', source: 'mouse' });
    }
  } else if (target.type === 'cell') {
    if (extend && state.mode === 'cell' && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToCell',
        cell: target.position,
        source: 'mouse',
      });
    } else {
      machine.dispatch({ type: 'selectCell', cell: target.position, source: 'mouse' });
      if (isCellSelected(state, target.position)) {
        machine.dispatch({
          type: 'startEditing',
          cell: target.position,
          source: 'mouse',
        });
      }
    }
  } else if (target.type === 'row') {
    if (extend && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToRow',
        row: target.row,
        source: 'mouse',
      });
    } else if (target.source === 'row-handle') {
      if (toggle) {
        machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
      } else {
        machine.dispatch({
          type: 'selectRows',
          ranges: [
            {
              anchor: {
                row: target.row,
                col: {
                  index: 0,
                },
              },
              lead: {
                row: target.row,
                col: {
                  index: 0,
                },
              },
            },
          ],
          source: 'mouse',
        });
      }
    } else {
      machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
    }
  } else if (target.type === 'column') {
    if (extend && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToColumn',
        col: target.col,
        source: 'mouse',
      });
    } else if (toggle) {
      machine.dispatch({ type: 'toggleColumn', col: target.col, source: 'mouse' });
    } else {
      machine.dispatch({
        type: 'selectColumns',
        ranges: [
          {
            anchor: {
              col: target.col,
              row: {
                index: 0,
              },
            },
            lead: {
              col: target.col,
              row: {
                index: 0,
              },
            },
          },
        ],
        source: 'mouse',
      });
    }
  }
}
